import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import AppShell from "@/components/AppShell";
import Overview from "@/pages/Overview";
import Scan from "@/pages/Scan";
import Diagnose from "@/pages/Diagnose";
import Prescribe from "@/pages/Prescribe";
import Transform from "@/pages/Transform";
import Sustain from "@/pages/Sustain";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div
        data-testid="app-loading"
        className="min-h-screen flex items-center justify-center mono text-[color:var(--text-2)]"
      >
        <span className="mono-loader">
          initializing<span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  return (
    <Routes>
      <Route
        path="/login"
        element={
          loading ? null : user ? <Navigate to="/" replace /> : <Login />
        }
      />
      <Route
        path="/"
        element={
          <Protected>
            <AppShell />
          </Protected>
        }
      >
        <Route index element={<Overview />} />
        <Route path="scan" element={<Scan />} />
        <Route path="diagnose" element={<Diagnose />} />
        <Route path="prescribe" element={<Prescribe />} />
        <Route path="transform" element={<Transform />} />
        <Route path="sustain" element={<Sustain />} />
        <Route path="users" element={<Users />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#0e0e0e",
                border: "1px solid #27272a",
                color: "#fff",
                borderRadius: "4px",
                fontFamily: "JetBrains Mono, monospace",
                fontSize: "13px",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
